import { render, staticRenderFns } from "./sub-head-primary.vue?vue&type=template&id=6266c6fe&scoped=true&"
import script from "./sub-head-primary.vue?vue&type=script&lang=js&"
export * from "./sub-head-primary.vue?vue&type=script&lang=js&"
import style0 from "./sub-head-primary.vue?vue&type=style&index=0&id=6266c6fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6266c6fe",
  null
  
)

export default component.exports